;(function (win) {
  let serialize = require('form-serialize');

  class PayPalPayment {
    constructor (options = {}) {
      this.createPaymentUrl  = options['createPaymentUrl']  || '';
      this.executePaymentUrl = options['executePaymentUrl'] || '';
      this.environment       = options['environment']       || 'sandbox';
      this.locale            = options['locale']            || 'en_US';
      this.buttonSelector    = options['button']            || 'paypal-button';
      this.formSelector      = options['form']              || 'payment-form';
    }

    paymentUrl(baseUrl) {
      pForm = document.getElementById(this.formSelector)
      if (!pForm) { return baseUrl; }

      let conntector = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${conntector}${serialize(pForm)}`;
    }

    renderButton() {
      let self = this
      let payPalButton = document.getElementById(self.buttonSelector);

      if (!payPalButton) { return; }

      // clean payPalButton content if we want re-render button
      // faster than `payPalButton.innerHTML = '';`
      while (payPalButton.firstChild) {
        payPalButton.removeChild(payPalButton.firstChild);
      }

      paypal.Button.render({
        env: self.environment,
        locale: self.locale,
        style: {
          tagline: false,
          size: 'large',
          shape: 'pill',
          color: 'gold'
        },
        commit: true,

        payment: function () {
          return paypal.request.post(self.paymentUrl(self.createPaymentUrl)).then(function (data) {
            return data.id;
          });
        },

        onAuthorize: function (data) {
          return paypal.request.post(self.paymentUrl(self.executePaymentUrl), {
            paymentID: data.paymentID,
            payerID: data.payerID
          }).then(function (data) {
            window.location.href = data.url;
          }, function (data) {
            window.location.href = data.url;
          });
        }
      }, payPalButton);
    }

  }

  win.PayPalPayment = PayPalPayment;

}(window))


// WEBPACK FOOTER //
// ./app/webpacker/src/js/payments/paypal.js